import { render, staticRenderFns } from "./createPdvsEvento.vue?vue&type=template&id=6a38c534&scoped=true&"
import script from "./createPdvsEvento.vue?vue&type=script&lang=js&"
export * from "./createPdvsEvento.vue?vue&type=script&lang=js&"
import style0 from "./createPdvsEvento.vue?vue&type=style&index=0&id=6a38c534&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a38c534",
  null
  
)

export default component.exports